const initializeMobileNavigation = () => {
  const nav = document.querySelector('#ms-mobile-navigation')
  if (!nav) {
    return
  }
  nav.querySelectorAll('.ms-expandable').forEach(expandable => {
    const titleRow = expandable.querySelector('.ms-title-row')
    titleRow.addEventListener('click', e => {
      e.preventDefault()
      expandable.classList.toggle('open')
      titleRow.querySelector('.ms-icon').classList.toggle('open')
    })
  })
}


document.addEventListener("DOMContentLoaded", _event => {
  initializeMobileNavigation()
})
